<template>
  <div class="row">
    <div class="col-md-12 mb-4">
      <div class="card">
        <div class="card-body">
          <div class="form-row justify-content-md-center">
            <div class="col-md-4">
              <div
                class="alert alert-danger text-center"
                role="alert"
                v-if="metricAmountactual === 0"
              >No existe meta para este mes</div>
            </div>
          </div>
          <div class="col-md-8 offset-md-2">
            <h5 class="card-title center">
              Meta del mes
              <br />
              $ {{ metricAmountactual | formatNumberCurrency }}
            </h5>
            <div class="form-row justify-content-md-center">
              <div class="form-group col-md-6">
                Tipo de meta:
                <br />
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="amount"
                    value="Adelantos liquidados"
                    v-model="input.metricType"
                  />
                  <label class="form-check-label" for="inlineRadio1">Adelantos liquidados</label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="fee"
                    value="Comisión"
                    v-model="input.metricType"
                  />
                  <label class="form-check-label" for="inlineRadio2">Comisión</label>
                </div>
              </div>
            </div>
            <div class="form-row justify-content-md-center">
              <div class="form-group col-md-6">
                <label for="inputEmail4">Monto</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">$</div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    v-model="input.metricAmount"
                    id="inlineFormInputGroup"
                    placeholder="Monto"
                  />
                </div>
                <small
                  id="amountHelp"
                  class="form-text text-muted"
                  v-if="input.metricType === 'Adelantos liquidados'"
                >Se toma en cuenta Monto otorgado + comisión + IVA</small>
                <small
                  id="amountHelp"
                  class="form-text text-muted"
                  v-else
                >Solo toma en cuenta la comisión de los adelantos.</small>
              </div>
            </div>
            <div class="form-row justify-content-md-center">
              <div class="form-group col-md-6 mb-2 mt-2">
                <button
                  type="submit"
                  class="btn btn-orange"
                  @click="addMonthMetricsUtility"
                  style="width: 100%"
                >
                  <span v-if="metricAmountactual === 0">Agregar</span>
                  <span v-else>Modificar</span> meta del mes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <ReportUtility v-if="renderComponent"></ReportUtility>
    </div>
  </div>
</template>
<script>
import ReportUtility from './ReportUtility.vue'
import axiosAdelaService from '@/axios/axiosAdelaService'

export default {
  components: {
    ReportUtility
  },
  data () {
    return {
      renderComponent: true,
      metricAmountactual: 0,
      input: {
        metricAmount: '',
        metricType: 'Adelantos liquidados'
      }
    }
  },
  methods: {
    async addMonthMetricsUtility () {
      try {
        const request = {
          ...this.input
        }
        console.log(request)
        const response = await axiosAdelaService.post('/addMonthMetricsUtility', request)
        if (response.status === 200) {
          this.renderComponent = false
          this.$toastedPush({
            message: 'Se agregó la meta del mes.',
            type: 'success'
          })
          this.MonthMetricsUtility()
          this.$nextTick(() => {
            this.renderComponent = true
          })
        }
      } catch (error) {
        this.showError('No se pudo agregar la meta del mes, intentalo más tarde.')
      }
    },
    async MonthMetricsUtility () {
      try {
        const request = {
          Month: new Date().getMonth() + 1,
          Year: new Date().getFullYear()
        }
        const response = await axiosAdelaService.post('/getMonthMetricsUtility', JSON.stringify(request))
        console.log(response)
        if (response.status === 200 && response.data.length > 0) {
          this.metricAmountactual = response.data[0].amount
          this.input.metricAmount = response.data[0].amount
          this.input.metricType = response.data[0].type
        }
      } catch (error) {
        this.balance = 0
        this.showError('No se pudieron obtener la meta de este mes.')
      }
    }
  },
  mounted () {
    this.MonthMetricsUtility()
  }
}
</script>
